/*
 * 会员VIP LV 等级图标
 *
 * Author: FJJ
 * History:
 * Date      Version Remarks
 * ========= ======= ======================================================
 * 2023.02.17      1.0     First version
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 */
import React  from 'react';
import PropTypes from "prop-types"; 

export default class VipLvLevel extends React.Component {
    static propTypes = {
        grade: PropTypes.number,//等级
        width: PropTypes.number
    };
    static defaultProps = {
        grade: 0,
        width: 58,
    };
    getLv(grade){
        switch (grade) {
            case 1:
                return "https://oss.essaone.com/ccfbe1da-ed7f-498c-8857-0ca4680d0a0f.png";
            case 2:
                return "https://oss.essaone.com/f6481ef4-f144-4a39-abb4-4ecbb44a6473.png";
            case 3:
                return "https://oss.essaone.com/751dbac8-35ac-4d1f-bc42-2cdc2db777e7.png";
            case 4:
                return "https://oss.essaone.com/c6fc8539-0a1b-44ba-813a-92368a62179a.png";
            case 5:
                return "https://oss.essaone.com/318a60b0-69e1-4e65-b058-82798dbd1e7d.png";
            case 6:
                return "https://oss.essaone.com/85f761a1-4e25-41e6-8e60-b73e0065da66.png";
            case 7:
                return "https://oss.essaone.com/2d7b828c-8859-4120-95e6-260d35b91e42.png";
            default: //0
                return "https://oss.essaone.com/e7b8c013-ae43-43ec-bb35-e43d6017724f.png";
        }
    }
    render() {
        const { grade, width,} = this.props;
        return (<img src={this.getLv(grade)} alt="" style={{width:width+'px'}}/>);
    }
}